<section class="width-100">
  <h4>{{label}}</h4>
  <mat-button-toggle-group [formControl]="valueForm">
    <mat-button-toggle [value]=true>TAK</mat-button-toggle>
    <mat-button-toggle [value]=false>NIE</mat-button-toggle>
    <mat-button-toggle [value]=null>BRAK INFORMACJI</mat-button-toggle>
  </mat-button-toggle-group>
</section>
